export default __webpack_public_path__ + "static/media/Описание интерфейса.d59cec74.md";